import React, { useEffect, useState } from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import dayjs from 'dayjs';

export default function BasicDatePicker({
  value,
  onChange,
  label = 'Select Date',
  disablePast = true,
  disabled = false,
  defaultValue = null,
  format = 'LL',
  sx = {},
  ...rest
}) {
  const [internalValue, setInternalValue] = useState(defaultValue ? dayjs(defaultValue) : null);

  const isControlled = value !== undefined && onChange !== undefined;
  const pickerValue = isControlled ? value : internalValue;

  const handleChange = (newValue) => {
    if (!isControlled) {
      setInternalValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        value={pickerValue}
        onChange={handleChange}
        label={label}
        disablePast={disablePast}
        disabled={disabled}
        format={format}
        sx={{ width: '100%', ...sx }}
        {...rest}
      />
    </LocalizationProvider>
  );
}